export default __webpack_public_path__ + "static/media/jane-churchyard-benefits-5.c3bcdd16.jpg";